<template>
  <div class="animated fadeIn">
    <b-card header="메뉴 전체 리스트">
      <b-tabs pills card vertical>
        <b-tab :active="index === 0" v-for="(item, index) in list">
          <template slot="title">
            {{item.upperMenu.menuName}}
            <b-link :to="{name: 'menuEdit', params: {menuId: item.upperMenu.menuId}}" class="mod ml-3">[수정]</b-link>
          </template>
          <ul v-if="item.lowerMenuList.length > 0">
            <li v-for="(lowerMenu, index) in item.lowerMenuList">
              {{lowerMenu.menuName}}
              <b-link :to="{name: 'menuEdit', params: {menuId: lowerMenu.menuId}}">[수정]</b-link>
            </li>
          </ul>
          <span v-else>하위 메뉴 없음</span>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
  import AuthService from '@/common/api/auth.service'
  import { mapMutations } from 'vuex'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import { $showModalWithErrorMsg } from '@/common/util'
  export default {
    data () {
      return {
        list: [],
        upperMenu: null,
        upperMenuList: [
          {
            menuName:'없음',
            url: '',
            upperId: 0,
            menuId: 0
          },
        ],
        menuDto: {
          upperId: 0,
          menuName: '',
          url: '',
          icon: '',
          titleYn: true
        }
      }
    },
    mounted () {
      AuthService.getMenuList()
        .then(({data})=> {
          this.list = data
          console.log(data)
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    methods: {
      removeMenu (lowerMenu) {

      },
      submitHandling () {
        AuthService.createMenu(this.menuDto)
      },
      resetUpperId () {
        this.menuDto.upperId = 0
        this.menuDto.url = ''
        this.upperMenu = null
      },
      ...mapMutations('ui', [SHOW_MODAL])
    }
  }
</script>
<style scoped>
  .nav-link.active .mod{
    color: #fff
  }
</style>
